module.exports = __webpack_public_path__ + "media/images/onsen-long-a335e083eeea0a860f6c7e575e92da41.jpg";